import { searchProductsParams } from './params/search-products-params'
import { sizeTypeAggregationFields } from './fragments/size-type-aggregation-fields'
import { filtersVariables } from './variables/filters-variables'

export const querySearchSizes = /* GraphQL */ `
  query searchSizes(
    $term: String!,
    ${filtersVariables}
  ) {
    search(products: ${searchProductsParams}) {
      products {
        aggregations {
          size_types {
            ...sizeTypeAggregationFields
          }
        }
      }
    }
  }

  ${sizeTypeAggregationFields}
`
